import { NgModule } from '@angular/core';
import { PorcentajePipe } from './porcentaje.pipe';
import { RedondearPipe } from './redondear.pipe';
import { ConvertToArrayPipe } from './convert-to-array.pipe';
import { DateFullPipe } from './date-full.pipe';
import { ColorEventoPipe } from './color-evento.pipe';
import { ReversePipe } from './reverse.pipe';
import { ReplacePipe } from './replace.pipe';

@NgModule({
  declarations: [
    PorcentajePipe,
    RedondearPipe,
    ConvertToArrayPipe,
    DateFullPipe,
    ColorEventoPipe,
    ReversePipe,
    ReplacePipe
  ],
  exports: [
    PorcentajePipe,
    RedondearPipe,
    ConvertToArrayPipe,
    DateFullPipe,
    ColorEventoPipe,
    ReversePipe,
    ReplacePipe
  ]
})
export class PipesModule { }
